export const CATEGORIES = [
    { key: "hote", label: "Hôte / Hôtesse d'accueil" },
    { key: "agent_accueil", label: "Agent d'accueil" },
    { key: "groom", label: "Groom / Bagagiste" },
    { key: "serveur", label: "Serveur / Serveuse" },
    { key: "chef_de_rang", label: "Chef de rang" },
    { key: "maitre_hotel", label: "Maître d'hôtel" },
    { key: "barman", label: "Barman / Barmaid" },
    { key: "cuisinier", label: "Cuisinier" },
    { key: "chef_cuisine", label: "Chef de cuisine" },
    { key: "plongeur", label: "Plongeur" },
    { key: "commis", label: "Commis de cuisine" },
    { key: "livreur", label: "Livreur / Coursier" },
    { key: "femme_de_menage", label: "Agent d'entretien / Femme de ménage" },
    { key: "manutentionnaire", label: "Manutentionnaire" },
    { key: "personnel_logistique", label: "Personnel logistique" },
    { key: "chef_equipe", label: "Chef d'équipe" },
    { key: "animateur", label: "Animateur commercial" },
    { key: "personnel_evenementiel", label: "Personnel événementiel" },
    { key: "autre", label: "Autre besoin" },
];

// Métiers nécessitant une carte / agrément spécifique pour un auto-entrepreneur.
// Affiché en badge dans le Configurator + inscription candidat pour éviter les refus tardifs.
export const REGULATED_JOBS = {
    cuisinier: {
        label: "HACCP recommandé",
        detail: "Formation Hygiène Alimentaire (HACCP) fortement conseillée pour toute intervention en cuisine.",
    },
    chef_cuisine: {
        label: "HACCP fortement recommandée",
        detail: "La formation Hygiène Alimentaire (HACCP) est exigée par la majorité des donneurs d'ordre pour un chef ou responsable de cuisine. Obligation légale sur au moins une personne de l'établissement (donneur d'ordre).",
    },
    livreur: {
        label: "Assurance transport recommandée",
        detail: "Pour livraison > 3,5 t : capacité de transport léger obligatoire. Pour tout véhicule : assurance transport de marchandises recommandée.",
    },
};

export const SKILLS = [
    { key: "english_pro", label: "Anglais professionnel" },
    { key: "bilingual", label: "Bilingue confirmé" },
    { key: "team_leader", label: "Chef d'équipe" },
    { key: "driving_license", label: "Permis de conduire exigé" },
    { key: "own_vehicle", label: "Véhicule personnel exigé" },
    { key: "experience_3y", label: "3+ ans d'expérience" },
    { key: "luxury_vip", label: "Expérience luxe / VIP" },
    { key: "own_uniform", label: "Tenue personnelle imposée" },
    { key: "solo_mission", label: "Mission réalisée seul" },
    { key: "high_autonomy", label: "Autonomie élevée" },
    { key: "high_responsibility", label: "Forte responsabilité" },
    { key: "cash_handling", label: "Manipulation d'argent" },
    { key: "diploma_required", label: "Diplôme obligatoire" },
    { key: "pro_card_required", label: "Carte professionnelle obligatoire" },
];

export const categoryLabel = (k) =>
    CATEGORIES.find((c) => c.key === k)?.label || k;

export const fmtEUR = (v) =>
    new Intl.NumberFormat("fr-FR", {
        style: "currency",
        currency: "EUR",
    }).format(Number(v || 0));
